import styled from 'styled-components'

export const ContentContainer = styled.div`
  display: flex;
  width: 1280px;
  margin: 40px 0;
  justify-content: space-between;
`
export const CardEl = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${(props) => props.theme.colors.developer.background};
  padding: 24px;
  min-height: 352px;
  border-radius: 24px;
  overflow: hidden;
`

export const HeaderElement = styled.div`
  padding: 0 320px 100px 0;
`
export const Title = styled.h3`
  font-size: 30px;
  line-height: 1.2;
  color: ${(props) => props.theme.colors.text};
  font-weight: 600;
  text-transform: uppercase;
  padding-bottom: 24px;
  min-height: 60px;
`
export const Description = styled.p`
  font-size: 20px;
  line-height: 1.5;
  padding-bottom: 20px;
  color: ${(props) => props.theme.colors.text};
`
export const ButtonWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`
export const ButtonDescription = styled.p`
  font-size: 20px;
  line-height: 1.5;
  white-space: pre-line;
  padding-bottom: 20px;
  text-align: right;
  max-width: 400px;
`
export const CustomLoader = styled.div`
  & > div {
    height: 64px;
    min-height: 64px !important;
    margin-right: 0px;
  }
  & button {
    width: 302px;
  }
  & .loader {
    transform: scale(0.8);
  }
`
